// @flow
import React from "react";
import PageContainer from "../containers/PageContainer";
import OrdersList from "../containers/OrdersList";
import { useTranslation } from 'react-i18next';


export default function OrdersView() {
    const { t } = useTranslation();
  return (
      <PageContainer title={t("Orders")} showShopToolbar={false}>
          <OrdersList />
    </PageContainer>
  );
}
